<template>
  <div class="main">
      <!-- 导航栏部分 -->
    <div class="nav">
      <van-nav-bar
        title="电子健康卡注册(1/2)"
        left-arrow
        @click-left="onClickLeft"
      />
    </div>
    <van-tabs v-model="questionForm.gender">
        <van-tab title="手动输入">
            <van-form >
                    <van-field
                        v-model="questionForm.name"
                        name="用户名"
                        placeholder="用户名"
                        :rules="[{ required: true, message: '请填写用户名' }]"
                    />
                    <!-- 性别单选框 -->
                    <van-field name="gender" label="性别">
                    <template #input>
                        <van-radio-group v-model="questionForm.gender" direction="horizontal">
                        <van-radio name="1">男</van-radio>
                        <van-radio name="2">女</van-radio>
                        </van-radio-group>
                    </template>
                    </van-field>
                    <!-- 标签 -->
                    <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="questionForm.nation"
                        label="民族"
                        placeholder="点击选择民族"
                        @click="showPicker = true"
                    />
                    <van-field
                        v-model="questionForm.address"
                        name="地址"
                        placeholder="地址"
                        :rules="[{ required: true, message: '请填写地址' }]"
                    />
                    <van-field
                        v-model="questionForm.idNumber"
                        type="textarea"
                        rows="1"
                        autosize
                        size="large"
                        placeholder="请输入证件号码"
                        :rules="[
                        {
                            message: '证件号码格式不正确',
                            validator: certificateNoValidator,
                        },
                        ]"
                        @blur="getIdname(questionForm.idNumber)"
                    />                    
                    <!-- 标签方法范围 -->
                    <van-popup v-model="showPicker" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="nationOBJ"
                        @confirm="onConfirm"
                        @cancel="showPicker = false"
                    />
                    </van-popup>
                    <div style="margin: 16px;" @click="addphone">
                        <van-button round block type="info" >下一步，填写手机号</van-button>
                    </div>
            </van-form>
            <div class="relevance" @click="relevance()">
                已 有 健 康 卡，一 键 快 速 关 联 >
            </div>
        </van-tab>
    <!-- <van-tab title="上传身份证">
        <div class="personal-reg-uplod_1">
            <van-uploader v-model="fileList" class="personal-reg-uplod_2"
             multiple
             preview-size="120px"
             :upload-icon="require('../ElectronicHealthCard/PictureHealthCardImg/uploadid.6037d2f6.png')"
             :max-count="1"/>
             <div class="format">
                <div class="hint">
                    <img src="../ElectronicHealthCard/PictureHealthCardImg/hint.png" alt="">
                    <div>照片要求</div>
                </div>
                    <div class="hint_text">
                    <p>保持证件边框完整</p>
                    <p>不要过远拍摄</p>
                    <p>避免模糊，文字清晰可见</p>
                    </div>
                    <div class="relevance">
                     <p  >   已 有 健 康 卡，一 键 快 速 关 联 </p>
                    </div>
            </div>
        </div>
    </van-tab> -->
    </van-tabs>
  </div>
</template>

<script>
import Nav from "../ElectronicHealthCard/components/nav.vue";
import uploadIcon from '../ElectronicHealthCard/PictureHealthCardImg/uploadid.6037d2f6.png';
export default{
    data(){       
        return{
            showPicker: false,
            nationOBJ: [
                "汉族",
                "蒙古族",
                "回族",
                "藏族",
                "维吾尔族",
                "苗族",
                "彝族",
                "壮族",
                "布依族",
                "朝鲜族",
                "满族" ,
                "侗族",
                "瑶族",
                "白族",
                "土家族",
                "哈尼族",
                "哈萨克族",
                "傣族",
                "黎族",
                "傈僳族",
                "佤族",
                "畲族",
                "高山族",
                "拉祜族",
                "水族",
                "东乡族",
                "纳西族",
                "景颇族",
                "柯尔克孜族",
                "土族",
                "达斡尔族",
                "仫佬族",
                "羌族",
                "布朗族",
                "撒拉族",
                "毛难族",
                "仡佬族",
                "锡伯族",
                "阿昌族",
                "普米族",
                "塔吉克族",
                "怒族",
                "乌孜别克族",
                "俄罗斯族",
                "鄂温克族",
                "崩龙族",
                "保安族",
                "裕固族",
                "京族",
                "塔塔尔族",
                "独龙族",
                "鄂伦春族",
                "赫哲族",
                "门巴族",
                "珞巴族",
                "基诺族",
            ],
            questionForm: {
                wechatCode:'',
                gender: '',
                nation: '',
                name:'',
                address:'',
                birthday:'',
                idNumber:'',
                phone1:'',
                phone2: '',
                patid: '',
                idType: '',
                relation:'',
                cityCode:'',
            },
            fileList: [],
        }
    },
       
    mounted() {
         // 接参：wechatCode、
        this.questionForm.wechatCode = this.$route.query.wechatCode
        this.questionForm.patid = this.$route.query.clientId
    },
    methods:{

        getIdname(num){
            this.getBindFormData(num);
        },
        uploadFile(){

        },
        onClickLeft() {
        this.$router.push('/index');
        },
        // 选择民族
        onConfirm(nation) {
            this.questionForm.nation =nation;
            this.showPicker = false;
        },

        getBindFormData(val) {
            if(val){
                this.questionForm.birthday = this.getBirthday(
                    val
                );
            }
            // console.log(123)

        },
        // 通过身份证号码获取生日
        getBirthday(idCard) {
            let birthday = "";
            if (idCard != null && idCard !== "") {
            if (idCard.length === 15) {
                birthday = "19" + idCard.substr(6, 6);
            } else if (idCard.length === 18) {
                birthday = idCard.substr(6, 8);
            }
                birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
            }
            return birthday;
        },
        // 表单提交
        addphone(values) {
            var questionForm = this.questionForm;
            this.$router.push({
                name:'personal2',
                params:{
                    questionForm,
                }
            });
        },
        // 一键注册
       async relevance(){
           try {
        this.$showLoad();
        let data = {
          redirect_uri: `https://account.kmmds.top/HealthcardList`,
        };
        let url = "/healthcardcontroller/getHealthCode";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
               this.$hideLoad();
            if (data.status == 200 && data.data.url) {
              window.location.href = data.data.url;
            } else {
              this.$toast.fail("网络出错，稍后重试");
              return;
            }
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
        },
        // 证件号码校验
        certificateNoValidator(value) {
        if (this.questionForm.idNumber === "1")
            return /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/.test(value);
        return true;
        },


    }
}
</script>

<style lang="scss" scoped>
.main {
    width: 100%;
    height: 100%;
    background-color: rgb(245, 245, 245);
}

.relevance{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #5d8bF6;
    line-height: 4vh;
}

.format {
    display: flex;
    flex-direction: column;
    width: 100%;
    border-top: 1px solid #ccc;
    margin-bottom: 15px;
    background-color: #fff;
}
.hint_text{
    font-size: 12px;
    margin: 5px 0 10px 15px;
}
.hint{
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 25px;
    width: 100px;
    height: 25px;
    font-size: 15px;
    color: #FB8C00;
    border:1px solid #FB8C00;

}
.hint img {
    width: 20px;
    height: 20px;
}
.personal-reg-uplod_1{
    width: 90%;
    margin: 0px auto;
    background-color:#FFFFFF;
    border-radius: 3px;
}
.personal-reg-uplod_2{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90%;
    height: 220px;
    margin: 10px auto;
}
 .personal-reg-uplod_input{
    width: 100%;
    height: 100%;
    opacity: 0;
}
::v-deep .van-icon__image  {
    width: 13em;
    height: 9em;
    object-fit: contain;
}

</style>
